import { useState, useEffect, useRef } from "react";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import { useParams, useNavigate } from "react-router-dom";
import "../../style/infosubasta.css";
import api from "../../utils/apiClient";
import FooterMovil from "../FooterMovil";
import PopupLogged from "../PopupLogged";
import { useAuth } from "../../context/AuthContext.js";
import Popup360 from '../Popup360'; 
import Popup from '../Popup';
import AutoBidModal from '../AutoBidModal';
import PaymentModal from '../PaymentModal';
import usePayment from '../../hooks/usePayment';
import { io } from 'socket.io-client';


const pad = (n) => String(n).padStart(2, "0");

function formatearConIntl(isoString) {
  const date = new Date(isoString);

  // 1. Detect if your runtime/browser supports America/El_Salvador
  let tz = "America/El_Salvador";
  try {
    // This will throw if the timeZone is invalid
    Intl.DateTimeFormat(undefined, { timeZone: tz }).format();
  } catch {
    tz = undefined;  // fallback to local zone
  }

  // 2. Build the parts
  const parts = new Intl.DateTimeFormat("es-SV", {
    timeZone: tz,
    day:   "numeric",
    month: "long",
    year:  "numeric",
    hour:   "numeric",    // we’ll pad manually
    minute: "2-digit",
    hour12: true,
  }).formatToParts(date);

  // 3. Turn the array into a lookup
  const obj = {};
  for (const { type, value } of parts) {
    if (type !== "literal") obj[type] = value;
  }

  // 4. Zero-pad hour and normalize period
  const hour = obj.hour.padStart(2, "0");       // ensures "09" instead of "9"
  const minute = obj.minute;                    // already 2-digit
  const period = obj.dayPeriod.toLowerCase();   // "a. m." or "p. m."

  // 5. Assemble final string
  return `${obj.day} de ${obj.month} de ${obj.year}, ${hour}:${minute} ${period}`;
  }
  
function InfoCar() {
  const [socket, setSocket] = useState(null);
  const {
    showPaymentModal,
    openPaymentModal,
    closePaymentModal,
    confirmPayment,
    paymentSuccess,
    setPaymentSuccess,
    statusMsg,
    setStatusMsg,
    comprado,
    setcomprado,
    auctionId,
    setAuctionId,
    paymentsEnabled,
  } = usePayment();
  const [auction, setAuction] = useState(null);
  const [participando, setparticipando] = useState(false)
  const [showLoginPopup, setShowLoginPopup] = useState(false)
  const [step, setStep] = useState(100);
  const [bidOverride, setBidOverride] = useState(null);
  const [highestBid, setHighestBid] = useState(null);
  const [bids, setBids] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [myBid, setMyBid] = useState(null);
  const [outBid, setOutBid] = useState(false);
  const isWinning = myBid !== null && myBid === highestBid;
  // Time remaining until Fin ({days,hours,minutes,seconds}), or null when the
  // auction isn't live (not loaded yet / already over).
  const [endLeft, setEndLeft] = useState(null);
  // Once-only latch for the end-of-auction modal. Pre-armed on load when the
  // auction is already over, so viewing a historical auction never pops it.
  const endFiredRef = useRef(false);
  const [showComponentA, setShowComponentA] = useState(true);
  const [link360, setLink360] = useState("");
  const { authToken } = useAuth();

  const myBidRef = useRef(null);
  const minBid = highestBid !== null ? highestBid + step : step;
  const bidAmount = bidOverride ?? minBid;
  const canPlaceBid = highestBid === null || bidAmount > highestBid;
  // Recomputed every render — the endLeft tick re-renders each second while
  // live, so this flips to true right as the countdown reaches zero. The
  // backend rejects post-Fin bids regardless; this just disables the buttons.
  const auctionOver = !!auction && new Date(auction.Fin).getTime() <= Date.now();
  // Minimum meaningful max bid: one increment over the authoritative floor. The
  // floor mirrors the server's currentFloor = max(highestBid, PrecioInicial), so
  // a live-but-unbid auction (highestBid still falsy/unloaded) seeds the modal at
  // PrecioInicial + Salto — exactly what setMaxBid will accept — instead of the
  // bare `step` that `minBid` falls back to.
  const bidFloor = Math.max(Number(highestBid || 0), Number(auction?.PrecioInicial || 0));
  const maxBidMin = bidFloor + step;

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [wonAuction, setWonAuction] = useState(false);
  const [showAutoModal, setShowAutoModal] = useState(false);
  // The caller's server-side proxy max for this auction (eBay-style auto-bid the
  // backend runs even while offline). Replaces the old client-only auto-rebid.
  const [myMaxBid, setMyMaxBid] = useState(null);
  // True when the server retired my max (a rival exceeded it) — the amount
  // stays visible but marked agotada so the user knows to raise or bid.
  const [maxBidAgotada, setMaxBidAgotada] = useState(false);
  // Own user id, used to tell whether an incoming bidPlaced (manual OR placed by
  // my server proxy) is mine, so the "winning/outbid" status stays correct.
  const myUserIdRef = useRef(null);

  const toggleComponent = () => {
    setShowComponentA(!showComponentA);
  };

  const [car, setCar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();

  const [images, setimages] = useState([]);

  const [mainImage, setMainImage] = useState(images[0]);

  const handleIncrease = () => setBidOverride(bidAmount + step);
  const handleDecrease = () => setBidOverride(Math.max(bidAmount - step, minBid));
  const handleBidChange = (e) => {
    const val = e.target.value.replace(/,/g, '');
    const num = parseInt(val, 10);
    if (!isNaN(num)) setBidOverride(Math.max(num, minBid));
    else setBidOverride(minBid);
  };

  const requireAuth = () => {
    if (!authToken) {
      setShowLoginPopup(true);
      return false;
    }
    return true;
  };

  useEffect(() => {
    const socketUrl = process.env.REACT_APP_SOCKET_URL || 'http://localhost:8080';
    const socketPath = process.env.REACT_APP_SOCKET_PATH;

    const s = io(socketUrl, { path: socketPath });

    const handleConnectError = (error) => console.error('[socket] Connection error', error);
    s.on('connect_error', handleConnectError);

    setSocket(s);

    return () => {
      s.off('connect_error', handleConnectError);
      s.close();
    };
  }, []);

  useEffect(() => {
    if (!socket || !auctionId) return
    socket.emit('joinAuction', auctionId);
    socket.on('currentBids', (data) => {
      setBids(data);
    });
    socket.on('bidPlaced', (data) => {
      if (data.isHighest) {
        setHighestBid(data.amount);
      }
      // Soft close: the server may have extended Fin for a late bid — resync
      // so the "Termina en" countdown and the end trigger follow the new end.
      if (data.fin) {
        setAuction((prev) =>
          prev && String(prev.Fin) !== String(data.fin) ? { ...prev, Fin: data.fin } : prev
        );
      }
      // keep only the five most recent bids
      setBids(prev => [data, ...prev].slice(0, 5));
      const mine =
        data.user && myUserIdRef.current &&
        String(data.user._id) === String(myUserIdRef.current);
      if (mine) {
        // My own bid — placed manually OR by my server-side proxy. Track it; if
        // it's the leading bid I'm not outbid. (No client re-bidding anymore —
        // the backend proxy handles raising up to my max.)
        setMyBid(data.amount);
        myBidRef.current = data.amount;
        if (data.isHighest) setOutBid(false);
      } else if (myBidRef.current !== null && data.amount >= myBidRef.current) {
        // Someone else moved past my last bid. If my proxy still has headroom the
        // server counters automatically; I'm only truly outbid once it can't —
        // which also arrives as the outbid email.
        setOutBid(true);
      }
    });
    socket.on('maxbidRetired', (data) => {
      // Room-wide broadcast; only act on my own retirement.
      if (myUserIdRef.current && String(data.user) === String(myUserIdRef.current)) {
        setMaxBidAgotada(true);
      }
    });
    socket.on('bidRejected', (info) => {
      if (info?.reason === 'amount below minimum increment') {
        setStatusMsg(`Oferta muy baja. Mínimo requerido: ${info.required}`);
      } else if (info?.reason === 'unauthorized' || info?.reason === 'invalid token' || info?.reason === 'user not found') {
        setStatusMsg('Inicia sesión para ofertar.');
        setShowLoginPopup(true);
      } else if (info?.reason === 'invalid amount') {
        setStatusMsg('Monto de oferta inválido.');
      } else if (info?.reason === 'necesitas un boleto para participar en la subasta') {
        setStatusMsg('Necesitas un boleto para participar.');
      } else {
        setStatusMsg('Oferta rechazada.');
      }
      // A rejected bid never advanced the price, so the user was NOT outbid —
      // leave the winning/outbid indicator alone; only real bidPlaced events
      // drive it.
    });
    return () => {
      socket.off('bidPlaced');
      socket.off('currentBids');
      socket.off('bidRejected');
      socket.off('maxbidRetired');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, auctionId]);

  useEffect(() => {
    if (!socket || !auctionId) return;
    const handleCount = (data) => setUserCount(data.count);
    socket.on('auctionUserCount', handleCount);
    return () => {
      socket.off('auctionUserCount', handleCount);
    };
  }, [socket, auctionId]);

  // Arm the end latch for auctions that are already over when the page loads,
  // BEFORE the ticking effect below runs its first tick.
  useEffect(() => {
    if (auction?.Fin && new Date(auction.Fin).getTime() <= Date.now()) {
      endFiredRef.current = true;
    }
  }, [auction]);

  // The auction ends at its scheduled Fin — never because bidding paused. One
  // 1s tick drives both the "Termina en" display and the single end-of-auction
  // trigger. The backend independently enforces Fin on every bid; this is just
  // the UI reaching the same moment.
  useEffect(() => {
    if (!auction?.Fin) return;
    const endMs = new Date(auction.Fin).getTime();
    const tick = () => {
      const diff = endMs - Date.now();
      if (diff <= 0) {
        setEndLeft(null);
        if (!endFiredRef.current) {
          endFiredRef.current = true;
          handleAuctionEnd();
        }
        return;
      }
      setEndLeft({
        days: Math.floor(diff / 86_400_000),
        hours: Math.floor(diff / 3_600_000) % 24,
        minutes: Math.floor(diff / 60_000) % 60,
        seconds: Math.floor(diff / 1000) % 60,
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
    // handleAuctionEnd reads highestBid; re-running on bid changes keeps its
    // closure fresh without a ref dance.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auction, highestBid]);

  const placeBid = () => {
    if (!socket || !auctionId) return;
    if (!requireAuth()) return;
    if (highestBid !== null && bidAmount <= highestBid) {
      alert('La oferta debe ser mayor que la actual');
      return;
    }
    socket.emit('placeBid', { auctionId, amount: bidAmount, token: authToken });
    setMyBid(bidAmount);
    myBidRef.current = bidAmount;
    setOutBid(false);
    setBidOverride(null);
  };

  // Cancel a pre-registered max. The backend only allows it while the auction
  // is still upcoming — once live, a committed proxy can't be retracted.
  const cancelarMaxBid = async () => {
    if (!requireAuth() || !auctionId) return;
    try {
      await api.delete('maxbids/auction/' + auctionId);
      setMyMaxBid(null);
      setMaxBidAgotada(false);
      setStatusMsg('Oferta máxima cancelada');
    } catch (error) {
      setStatusMsg(error.response?.data?.error || 'No se pudo cancelar la oferta máxima');
    }
  };

  // Persist the user's proxy max on the server. The backend bids on their behalf
  // up to this amount (before AND during the auction) and emails them if a
  // competitor exceeds it.
  const submitMaxBid = async (max) => {
    if (!requireAuth()) return;
    if (!auctionId) return;
    try {
      const res = await api.post('maxbids', { auction: auctionId, maxAmount: max });
      const saved = res.data?.maxbid?.maxAmount ?? max;
      setMyMaxBid(saved);
      setMaxBidAgotada(false);
      if (res.data?.highestBid != null) setHighestBid(res.data.highestBid);
      // If the server's proxy bid immediately took the lead for us, seed local
      // ownership so "estás ganando" and later outbid detection are correct
      // without waiting on the socket echo.
      if (res.data?.highestBidder && String(res.data.highestBidder) === String(myUserIdRef.current)) {
        setMyBid(res.data.highestBid);
        myBidRef.current = res.data.highestBid;
        setOutBid(false);
      }
      setShowAutoModal(false);
      setStatusMsg(`Oferta máxima establecida en L.${formatNumberWithCommas(saved)}`);
    } catch (error) {
      const data = error.response?.data;
      const msg = data?.error === 'maxAmount below minimum'
        ? `La oferta máxima debe ser mayor. Mínimo: L.${formatNumberWithCommas(data?.required ?? 0)}`
        : data?.error === 'necesitas un boleto para participar en la subasta'
          ? 'Necesitas comprar un boleto para participar.'
          : data?.error || 'No se pudo establecer la oferta máxima';
      setShowAutoModal(false);
      setStatusMsg(msg);
    }
  };


  // Claim a free participation ticket (no payment processor). Writes the caller
  // into the auction's ticketBuyers server-side, then unlocks the bid / max-bid
  // controls. With payments on, ticketing goes through the PaymentModal instead.
  const claimTicket = async () => {
    if (!requireAuth()) return;
    if (!auctionId) return;
    try {
      await api.post('tickets', { auction: auctionId });
      setcomprado(true);
      setStatusMsg('Boleto obtenido. Ya puedes participar.');
    } catch (error) {
      setStatusMsg(error.response?.data?.error || 'No se pudo obtener el boleto');
    }
  };

  const handleImageClick = (imageUrl) => {
    setMainImage(imageUrl);
  };

  function checkBoolean(value) {
    return value ? "Si" : "No";
  }

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year

    return `${day}/${month}/${year}`;
  }

  const solicitarCompra = async () => {
    if(authToken){
      const data = {
        data: "data",
      };
      if(authToken){
        await api.post("ventas/solicitudcompra/" + id, data);
      }
    }
    const phoneNumber = "50499700699";
    const message = `quiero comprar el vehiculo ` + car.marca + " " + car.modelo + " " + car.anio + " numero de lote " + car.lote;
    const url = 'https://wa.me/' + phoneNumber + '?text=' + encodeURIComponent(message)
    await window.open(url, '_blank')
  };

  const enviarWhatsappGanado = async () => {
    const phoneNumber = "50499700699";
    const message = `he ganado la subasta de el carro ${car.marca} ${car.modelo} con numero de lote ${car.lote} con mi oferta de ${highestBid} lps.`;
    const url = 'https://wa.me/' + phoneNumber + '?text=' + encodeURIComponent(message);
    await window.open(url, '_blank');
  };

  // Purely informational: shows won/lost when the clock reaches Fin. Server
  // state is untouched from here — the cron hides finished auctions and an
  // admin marks ganado explicitly (the old client-side hide/ganado PATCHes
  // were sysadmin-gated no-ops for everyone else and killed the auction early
  // whenever an admin merely had the page open).
  const handleAuctionEnd = () => {
    if (myBidRef.current !== null && myBidRef.current === highestBid) {
      setModalMessage('Has ganado la subasta, por favor comunicate con el numero +504 9970-0699');
      setWonAuction(true);
    } else {
      setModalMessage('La subasta ha terminado gracias por participar');
      setWonAuction(false);
    }
    setShowModal(true);
  };


  useEffect(() => {
    const fetchAllCarros = async () => {
      setLoading(true);
      try {
        const response = await api.get("carro/" + id);
        setCar(response.data);
        let imageUrls = response.data.imagenes
        imageUrls = imageUrls.map(url => url.replace("http://", "https://"));
        setMainImage(imageUrls[0]);
        setimages(imageUrls);
        setLink360(response.data.link360);
        setError(null);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to fetch data");
        setCar([]);
        setLoading(false);
      }
    };
    const fetchAuction = async() => {
        try {
            const response = await api.get("auctions/vehicle/" + id);
            const parsedSalto = Number(response.data.Salto);
            const salto = Number.isFinite(parsedSalto) && parsedSalto > 0
              ? parsedSalto
              : 100;
            setStep(salto);
            await setAuction(response.data)
            await setAuctionId(response.data._id);
            if (response.data.highestBid) {
              setHighestBid(response.data.highestBid);
            }
          } catch (error) {
            // A missing/failed auction must not clobber the CAR that
            // fetchAllCarros loads in parallel — the page can still show the
            // vehicle without live auction data.
            console.error("Error fetching auction:", error);
            setError("Failed to fetch auction");
          }
    }
    fetchAllCarros();
    fetchAuction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Resolve the caller's id as soon as we have a token — independent of the
  // auction load / ticket check — so a bidPlaced for the user's own server-side
  // proxy is attributed to them even if it arrives before the ticket effect
  // resolves (otherwise their own leading bid can briefly read as a rival's).
  useEffect(() => {
    if (!authToken) return undefined;
    let cancelled = false;
    api.get('usuario/getbyToken')
      .then((res) => { if (!cancelled) myUserIdRef.current = res.data._id; })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [authToken]);

  useEffect(() => {
    const checkTicketBuyer = async () => {
      if (!auction || !authToken) return;
      try {
        let userId = myUserIdRef.current;
        if (!userId) {
          const res = await api.get('usuario/getbyToken');
          userId = res.data._id;
          myUserIdRef.current = userId;
        }
        if (auction.ticketBuyers && auction.ticketBuyers.includes(userId)) {
          setcomprado(true);
        }
        // Ownership survives reloads: the server-side proxy can hold the lead
        // while the user is away, so "am I winning" must come from the loaded
        // auction, not only from in-session bid events — otherwise a returning
        // leader sees a neutral circle and the LOSING modal at Fin.
        if (
          auction.highestBidder &&
          String(auction.highestBidder) === String(userId) &&
          auction.highestBid != null
        ) {
          setMyBid(auction.highestBid);
          myBidRef.current = auction.highestBid;
          setHighestBid(auction.highestBid);
          setOutBid(false);
        }
      } catch (error) {
        console.error('Error checking ticket buyer:', error);
      }
    };
    checkTicketBuyer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auction, authToken]);

  useEffect(() => {
    const fetchMyMaxBid = async () => {
      if (!auctionId || !authToken) return;
      try {
        const res = await api.get('maxbids/auction/' + auctionId);
        if (res.data && res.data.active) {
          setMyMaxBid(res.data.maxAmount);
          setMaxBidAgotada(false);
        } else if (res.data && res.data.notifiedOutbid) {
          // Retired by the proxy engine: show it as agotada instead of
          // pretending no max was ever set.
          setMyMaxBid(res.data.maxAmount);
          setMaxBidAgotada(true);
        }
      } catch (error) {
        // no max set / not eligible — leave unset
      }
    };
    fetchMyMaxBid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auctionId, authToken]);

  const participarbttn = () => {
    if (!authToken) {
      setShowLoginPopup(true);
      return;
    }
    if (auction && new Date(auction.Fin) <= new Date()) {
      setModalMessage('la subasta ha terminado');
      setShowModal(true);
      return;
    }
    setparticipando(true);
  }

  
  if (loading) {
    return <div>Cargando...</div>;
  }

  // Coarse phase for the header badge / info panel copy. Recomputed per render;
  // the 1s endLeft tick keeps it fresh while live, and the existing button
  // conditions below stay the authoritative gating.
  const started = auction && new Date(auction.Inicio).getTime() <= Date.now();
  const phase = !auction ? null : auctionOver ? 'ended' : started ? 'live' : 'upcoming';
  // What the price block shows: the live highest bid when there is one, else
  // the starting price (display only — bid floors are computed above).
  const displayPrice = highestBid ?? auction?.highestBid ?? auction?.PrecioInicial ?? 0;
  const displayPriceLabel =
    (highestBid ?? auction?.highestBid) != null ? 'Oferta actual' : 'Precio inicial';

  return (
    <>
      <Navbar />
      <div className="subasta-page">
        <div className="subasta-head">
          <h1 className="subasta-title">
            {car.marca} {car.modelo} {car.anio}
          </h1>
          {car.tipo !== 'Varios' && car.lote && (
            <span className="subasta-chip">Lote {car.lote}</span>
          )}
          {car.ubicacion && <span className="subasta-chip">{car.ubicacion}</span>}
          {phase === 'live' && (
            <span className="subasta-badge live">
              <span className="subasta-live-dot" />
              En vivo
            </span>
          )}
          {phase === 'upcoming' && <span className="subasta-badge soon">Próxima</span>}
          {phase === 'ended' && <span className="subasta-badge ended">Finalizada</span>}
          {phase === 'live' && userCount > 0 && (
            <span className="subasta-viewers">
              {userCount} {userCount === 1 ? 'persona viendo' : 'personas viendo'}
            </span>
          )}
        </div>

        <div className="subasta-layout">
          <div className="subasta-main">
            <div className="subasta-gallery-tools">
              <button className="change-set" onClick={toggleComponent}>
                Vista Completa
              </button>
              <Popup360 link360={link360} />
            </div>
            {showComponentA ? (
              <div className="subasta-gallery">
                {mainImage && <img src={mainImage} alt="" className="subasta-main-image" />}
                <div className="subasta-thumbs">
                  {images.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`Thumbnail ${index}`}
                      onClick={() => handleImageClick(image)}
                      className={'subasta-thumb' + (image === mainImage ? ' sel' : '')}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className="subasta-fullview">
                {images.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Thumbnail ${index}`}
                    className="subasta-fullview-img"
                  />
                ))}
              </div>
            )}
          </div>

          <div className="subasta-specs">
              <h2>Información del vehículo</h2>
              <div className="subasta-specs-grid">
                {car.tipo !== 'Varios' && (
                  <div className="spec-item">
                    <span className="spec-k">Lote</span>
                    <span className="spec-v">{car.lote}</span>
                  </div>
                )}
                <div className="spec-item">
                  <span className="spec-k" spellCheck="false" translate="no">Precio</span>
                  <span className="spec-v" spellCheck="false" translate="no">
                    Lps. {formatNumberWithCommas(car.offerta ? car.precioOferta : car.precio)}
                  </span>
                </div>
                <div className="spec-item">
                  <span className="spec-k">Fecha de publicación</span>
                  <span className="spec-v">{formatDate(car.createdAt)}</span>
                </div>
                {car.tipo !== 'Varios' ? (
                  <div className="spec-item">
                    <span className="spec-k">Marca</span>
                    <span className="spec-v">{car.marca}</span>
                  </div>
                ) : (
                  <div className="spec-item">
                    <span className="spec-k">Producto</span>
                    <span className="spec-v">{car.marca}</span>
                  </div>
                )}
                <div className="spec-item">
                  <span className="spec-k">Modelo</span>
                  <span className="spec-v">{car.modelo}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-k">Año</span>
                  <span className="spec-v">{car.anio}</span>
                </div>
                {car.millaje !== 0 && (
                  <div className="spec-item">
                    <span className="spec-k">Millaje</span>
                    <span className="spec-v">{car.millaje}</span>
                  </div>
                )}
                <div className="spec-item">
                  <span className="spec-k">Condición</span>
                  <span className="spec-v">{car.condicion}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-k">Tipo</span>
                  <span className="spec-v">{car.tipo}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-k">Ubicación</span>
                  <span className="spec-v">{car.ubicacion}</span>
                </div>
                {car.motor !== '0' && (
                  <div className="spec-item">
                    <span className="spec-k">Motor</span>
                    <span className="spec-v">{car.motor}</span>
                  </div>
                )}
                {car.combustible !== 'N/A' && (
                  <div className="spec-item">
                    <span className="spec-k">Combustible</span>
                    <span className="spec-v">{car.combustible}</span>
                  </div>
                )}
                {car.transmission !== 'N/A' && (
                  <div className="spec-item">
                    <span className="spec-k">Transmisión</span>
                    <span className="spec-v">{car.transmission}</span>
                  </div>
                )}
                {car.traccion !== 'N/A' && (
                  <div className="spec-item">
                    <span className="spec-k">Tracción</span>
                    <span className="spec-v">{car.traccion}</span>
                  </div>
                )}
                {car.listado && (
                  <div className="spec-item">
                    <span className="spec-k">Listado</span>
                    <span className="spec-v">{car.listado}</span>
                  </div>
                )}
                <div className="spec-item">
                  <span className="spec-k">Camina</span>
                  <span className="spec-v">{checkBoolean(car.camina)}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-k">Enciende</span>
                  <span className="spec-v">{checkBoolean(car.enciende)}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-k">Grua incluída</span>
                  <span className="spec-v">{checkBoolean(car.gruaIncluida)}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-k">Gastos de introducción</span>
                  <span className="spec-v">{checkBoolean(car.Introduccion)}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-k">Gastos de inscripción</span>
                  <span className="spec-v">{checkBoolean(car.gastosDeInscripcion)}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-k">Costo de Placas</span>
                  <span className="spec-v">{checkBoolean(car.costosPlacas)}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-k">Costo de Vías Públicas</span>
                  <span className="spec-v">{checkBoolean(car.viasPublicas)}</span>
                </div>
                {car.comentario !== '' && (
                  <div className="spec-item spec-item-wide">
                    <span className="spec-k">Comentario</span>
                    <span className="spec-v">{car.comentario}</span>
                  </div>
                )}
              </div>
              <PopupLogged solicitarCompra={solicitarCompra} />
          </div>

          <aside className="subasta-panel">
            {participando ? (
              <>
                <div
                  className={
                    'panel-status' + (outBid ? ' outbid' : isWinning ? ' winning' : '')
                  }
                >
                  {outBid
                    ? 'Te superaron — tu oferta ya no es la más alta'
                    : isWinning
                      ? 'Estás ganando esta subasta'
                      : 'Subasta en vivo'}
                </div>
                <div className="panel-price">
                  <div className="panel-price-label">{displayPriceLabel}</div>
                  <div className="panel-price-amount">
                    <small>L.</small> {formatNumberWithCommas(displayPrice)}
                  </div>
                </div>
                {endLeft && (
                  <div className="panel-countdown">
                    <span>Termina en</span>
                    <span className="panel-countdown-num">
                      {endLeft.days ? `${endLeft.days}d ` : ''}
                      {pad(endLeft.hours)}h {pad(endLeft.minutes)}m {pad(endLeft.seconds)}s
                    </span>
                  </div>
                )}
                <p className="panel-softclose">
                  Una oferta de último momento extiende el cierre. Todas las ofertas están en
                  Lempiras.
                </p>
                {myMaxBid != null && (
                  <div className={'panel-maxbid' + (maxBidAgotada ? ' maxbid-agotada' : '')}>
                    Tu oferta máxima: L.{formatNumberWithCommas(myMaxBid)}
                    {maxBidAgotada ? ' — agotada, súbela para seguir compitiendo' : ''}
                  </div>
                )}
                <div className="panel-form">
                  <div className="panel-stepper">
                    <button
                      className="panel-step"
                      onClick={handleDecrease}
                      aria-label="Bajar oferta"
                    >
                      −
                    </button>
                    <input
                      type="text"
                      className="panel-bid-input"
                      value={formatNumberWithCommas(bidAmount)}
                      onChange={handleBidChange}
                      aria-label="Tu oferta en Lempiras"
                    />
                    <button
                      className="panel-step"
                      onClick={handleIncrease}
                      aria-label="Subir oferta"
                    >
                      +
                    </button>
                  </div>
                  <p className="panel-min-hint">
                    Mínimo siguiente: L. {formatNumberWithCommas(minBid)} · salto L.{' '}
                    {formatNumberWithCommas(step)}
                  </p>
                  <button
                    className="panel-btn-primary"
                    onClick={placeBid}
                    disabled={!canPlaceBid || auctionOver}
                  >
                    Ofertar L. {formatNumberWithCommas(bidAmount)}
                  </button>
                  <button
                    className="panel-btn-ghost"
                    onClick={() => setShowAutoModal(true)}
                    disabled={auctionOver}
                  >
                    Definir oferta máxima
                  </button>
                  <p className="panel-ghost-hint">
                    El sistema puja por ti, solo lo necesario, hasta tu límite.
                  </p>
                </div>
                {myBid != null && (
                  <div className="panel-mybid">
                    Tu última oferta: <b>L. {formatNumberWithCommas(myBid)}</b>
                  </div>
                )}
                <div className="panel-history">
                  <h3>Ofertas anteriores</h3>
                  {bids.length === 0 && (
                    <p className="panel-history-empty">Aún no hay ofertas.</p>
                  )}
                  {bids.slice(0, 5).map((b, index) => {
                    const mine =
                      b.user &&
                      myUserIdRef.current &&
                      String(b.user._id) === String(myUserIdRef.current);
                    const isLeader = index === 0 && b.amount === highestBid;
                    return (
                      <div className="panel-history-row" key={index}>
                        <span className="panel-history-who">
                          {mine ? 'Tú' : b.user ? b.user.nombre : 'Oferente'}
                        </span>
                        {isLeader && <span className="panel-history-lead">líder</span>}
                        <span className="panel-history-amt">
                          L. {formatNumberWithCommas(b.amount)}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              <>
                <div className={'panel-status' + (phase === 'ended' ? ' ended' : '')}>
                  {phase === 'live'
                    ? 'Subasta en vivo'
                    : phase === 'upcoming'
                      ? 'Subasta programada'
                      : phase === 'ended'
                        ? 'Subasta finalizada'
                        : 'Información de la subasta'}
                </div>
                {auction && (
                  <div className="panel-price">
                    <div className="panel-price-label">{displayPriceLabel}</div>
                    <div className="panel-price-amount">
                      <small>L.</small> {formatNumberWithCommas(displayPrice)}
                    </div>
                  </div>
                )}
                {endLeft && phase === 'live' && (
                  <div className="panel-countdown">
                    <span>Termina en</span>
                    <span className="panel-countdown-num">
                      {endLeft.days ? `${endLeft.days}d ` : ''}
                      {pad(endLeft.hours)}h {pad(endLeft.minutes)}m {pad(endLeft.seconds)}s
                    </span>
                  </div>
                )}
                <div className="panel-info-rows">
                  <div className="panel-info-row">
                    <span>Inicio</span>
                    <span>{auction ? formatearConIntl(auction.Inicio) : '—'}</span>
                  </div>
                  <div className="panel-info-row">
                    <span>Fin</span>
                    <span>{auction ? formatearConIntl(auction.Fin) : '—'}</span>
                  </div>
                  <div className="panel-info-row">
                    <span>Precio inicial</span>
                    <span>
                      {auction ? `L. ${formatNumberWithCommas(auction.PrecioInicial)}` : '—'}
                    </span>
                  </div>
                  {auction && (
                    <div className="panel-info-row">
                      <span>Salto mínimo</span>
                      <span>L. {formatNumberWithCommas(step)}</span>
                    </div>
                  )}
                </div>
                <div className="panel-actions">
                  {auction && !comprado && new Date(auction.Fin) > new Date() && (
                    <button
                      onClick={paymentsEnabled ? openPaymentModal : claimTicket}
                      className="join-auction-btn"
                    >
                      {paymentsEnabled ? 'comprar boleto' : 'obtener boleto'}
                    </button>
                  )}
                  {auction && comprado && new Date(auction.Inicio) <= new Date() && (
                    <button
                      onClick={participarbttn}
                      disabled={auction && new Date(auction.Fin) <= new Date()}
                      className="join-auction-btn"
                    >
                      unirse a la subasta
                    </button>
                  )}
                  {auction && comprado && new Date(auction.Inicio) > new Date() && (
                    <>
                      <button
                        onClick={() => setShowAutoModal(true)}
                        className="join-auction-btn"
                      >
                        Definir oferta máxima
                      </button>
                      {myMaxBid != null && (
                        <>
                          <p className="panel-maxbid">
                            Tu oferta máxima: L.{formatNumberWithCommas(myMaxBid)}
                          </p>
                          {/* Cancelling is only allowed while the auction
                              hasn't started — once live, a committed proxy
                              can't be retracted (the backend enforces it). */}
                          <button onClick={cancelarMaxBid} className="cancel-maxbid-btn">
                            Cancelar oferta máxima
                          </button>
                        </>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </aside>
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            {wonAuction && (
              <button className="close-button" onClick={() => setShowModal(false)}>X</button>
            )}
            <p>{modalMessage}</p>
            {wonAuction && (
              <button className="red-button" onClick={enviarWhatsappGanado}>WhatsApp</button>
            )}
            {!wonAuction && (
              <button onClick={() => { setShowModal(false); navigate('/subastas'); }}>Cerrar</button>
            )}
          </div>
        </div>
      )}
      <PaymentModal
        show={showPaymentModal}
        onClose={closePaymentModal}
        onConfirm={confirmPayment}
        message={"Este pago es solamente una retención y será devuelto al finalizar la subasta. Exceptuando si usted es el ganador en ese caso se devolverá a la hora de finalizar la compra del vehículo"}
        amount={" 5,000 Lps."}
        paymentsEnabled={paymentsEnabled}
      />
      <AutoBidModal
        show={showAutoModal}
        onClose={() => setShowAutoModal(false)}
        onConfirm={submitMaxBid}
        minBid={maxBidMin}
      />
      {paymentSuccess && (
        <Popup
          message="pago exitoso"
          onClose={() => setPaymentSuccess(false)}
          duration={3000}
        />
      )}
      {statusMsg && (
        <Popup
          message={statusMsg}
          onClose={() => setStatusMsg('')}
          duration={3000}
        />
      )}
      {showLoginPopup && (
        <Popup
          message="Necesitas iniciar sesión para participar en las subastas"
          onClose={() => setShowLoginPopup(false)}
          duration={3000}
        />
      )}
    </>
  );
}

export default InfoCar;
